<template>
    <b-card no-body>
        <b-card-header class="border-0 location-table-headers">
            <div>
                <base-input label="Name" placeholder="Name" v-model="filters.name__icontains" />
            </div>
            <div>
                <base-input label="Search ID" placeholder="Search ID" v-model="filters.search_id__icontains" />
            </div>
            <router-link :to="'/location_report/new'">
                <base-button type="info">Create new report</base-button>
                <!-- <base-button icon type="info">
                    <span class="btn-inner--icon">
                        <i class="ni ni-fat-add"/>
                    </span>
                </base-button> -->
            </router-link>
        </b-card-header>
        <div v-if="isLoading">
            <card>Loading...</card>
        </div>
        <template v-else>
            <el-table class="table-responsive table"
                    header-row-class-name="thead-light"
                    :data="locationReports">
                <!-- <el-table-column label="ID" prop="id" /> -->
                <el-table-column label="Search ID" prop="search_id" />
                <el-table-column label="Name" prop="name" />
                <el-table-column label="Details" prop="_">
                    <template v-slot="{row}">
                        <b-media no-body class="align-items-center justify-content-end">
                            <router-link v-bind:key="row.id" :to="'/location_report/'+row.id">
                                <base-button icon type="info">
                                    <span class="btn-inner--icon">
                                        <i class="ni ni-align-center"/>
                                    </span>
                                </base-button>
                            </router-link>
                        </b-media>
                    </template>
                </el-table-column>
            </el-table>

            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination v-model="currentPage" :per-page="10" :total="total" @change="pageChanged">
                    <template v-slot:prev-text>
                        <a class="page-link" aria-label="Previous">
                            <span aria-hidden="true"><i class="fa fa-angle-left" aria-hidden="true"></i></span>
                        </a>
                    </template>
                </base-pagination>
            </b-card-footer>
        </template>
        
    </b-card>
</template>

<script>
import {Table,TableColumn} from 'element-ui'

import RepositoryFactory from "@/repositories/RepositoryFactory"

const LocationReportRepository = RepositoryFactory.get('location_report')

export default {
    name:'location-report-table',
    components:{
        [Table.name]:Table,
        [TableColumn.name]:TableColumn,
    },
    data(){
        return {
            currentPage:1,
            total:0,
            locationReports:null,
            lastRequestTimestamp:0,

            filters:{},
            filterTimer:undefined,

            isLoading:true,
        }
    },
    watch:{
        filters:{
            handler(oldVal,newVal){
                clearTimeout(this.filterTimer);
                this.isLoading=true;
                for(var i in this.filters){
                    if(this.filters[i]==="")
                        delete this.filters[i]
                    }
                this.filterTimer=setTimeout(() => this.filterTable(), 1000);
            },
            deep:true,
        }
    },
    created(){
        this.getPage(this.currentPage);
    },
    methods:{
        getPage(pageNumber){
            var timestamp=Date.now();
            this.lastRequestTimestamp=timestamp;

            this.isLoading=true;
            this.currentPage=pageNumber;

            LocationReportRepository.getTable(pageNumber,this.filters).then((response) => {
                if(this.lastRequestTimestamp!==timestamp) return;

                var r=response.data;

                this.locationReports=r.results;
                this.total=r.count;
                this.currentPage=pageNumber;

                this.isLoading=false;
            })
        },
        pageChanged(pageNumber){
            this.getPage(pageNumber);
        },
        filterTable(){
            this.isLoading=true;
            this.getPage(1);
        }
    }
}
</script>

<style>
.location-table-headers {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
}
</style>